
// 获取按期还款详细数据
export const GET_WHOLE_REPAY_INFO = 'GET_WHOLE_REPAY_INFO'

// 修改按期还款详细数据
export const SET_WHOLE_REPAY_INFO = 'SET_WHOLE_REPAY_INFO'

// 获取按期还款接口数据
export const GET_WHOLE_REPAY_DATA = 'GET_WHOLE_REPAY_DATA'

// 我要还款
export const GET_WHOLE_PERIOD_REPAY_INFO = 'GET_WHOLE_PERIOD_REPAY_INFO'

// 设置本期还没还款金额
export const SET_WHOLE_NOT_PAY_MONEY = 'SET_WHOLE_NOT_PAY_MONEY'



// WEBPACK FOOTER //
// ./src/vuex/types/personaCenter/wholeRepay.js